export default {
  BuiltInSlot: [
    {
      SlotType: "AMAZON.AT_CITY",
      BusinessDescription: "Name of the city"
    },
    {
      SlotType: "AMAZON.AT_REGION",
      BusinessDescription: "Name of the region"
    },
    {
      SlotType: "AMAZON.Actor",
      BusinessDescription: "Name of the actor"
    },
    {
      SlotType: "AMAZON.AdministrativeArea",
      BusinessDescription: "Name of the administrative area"
    },
    {
      SlotType: "AMAZON.AggregateRating",
      BusinessDescription: "Aggregate Rating number"
    },
    {
      SlotType: "AMAZON.Airline",
      BusinessDescription: "Name of the airline"
    },
    {
      SlotType: "AMAZON.Airport",
      BusinessDescription: "Name of the airport"
    },
    {
      SlotType: "AMAZON.Animal",
      BusinessDescription: "Name of the animal"
    },
    {
      SlotType: "AMAZON.Artist",
      BusinessDescription: "Name of the artist"
    },
    {
      SlotType: "AMAZON.Athlete",
      BusinessDescription: "Name of the athlete"
    },
    {
      SlotType: "AMAZON.Author",
      BusinessDescription: "Name of the author"
    },
    {
      SlotType: "AMAZON.Book",
      BusinessDescription: "Name of the book"
    },
    {
      SlotType: "AMAZON.BookSeries",
      BusinessDescription: "Name of the book series"
    },
    {
      SlotType: "AMAZON.BroadcastChannel",
      BusinessDescription: "Name of the broadcast channel"
    },
    {
      SlotType: "AMAZON.CivicStructure",
      BusinessDescription: "Name of the civic structure"
    },
    {
      SlotType: "AMAZON.Color",
      BusinessDescription: "Name of the colour"
    },
    {
      SlotType: "AMAZON.Comic",
      BusinessDescription: "Name of the comic"
    },
    {
      SlotType: "AMAZON.Corporation",
      BusinessDescription: "Name of the corporation"
    },
    {
      SlotType: "AMAZON.Country",
      BusinessDescription: "Name of the country"
    },
    {
      SlotType: "AMAZON.CreativeWorkType",
      BusinessDescription: "Name of the creative work type"
    },
    {
      SlotType: "AMAZON.DATE",
      BusinessDescription: "Date value"
    },
    {
      SlotType: "AMAZON.DURATION",
      BusinessDescription: "Duration value"
    },
    {
      SlotType: "AMAZON.DayOfWeek",
      BusinessDescription: "Day of the week"
    },
    {
      SlotType: "AMAZON.Dessert",
      BusinessDescription: "Name of the desert"
    },
    {
      SlotType: "AMAZON.DeviceType",
      BusinessDescription: "Device type name"
    },
    {
      SlotType: "AMAZON.Director",
      BusinessDescription: "name of the director"
    },
    {
      SlotType: "AMAZON.Drink",
      BusinessDescription: "Name of the drink"
    },
    {
      SlotType: "AMAZON.EUROPE_CITY",
      BusinessDescription: "Name of the European city"
    },
    {
      SlotType: "AMAZON.EducationalOrganization",
      BusinessDescription: "Name of the educational organization"
    },
    {
      SlotType: "AMAZON.EmailAddress",
      BusinessDescription: "Email address value"
    },
    {
      SlotType: "AMAZON.EventType",
      BusinessDescription: "Event type value"
    },
    {
      SlotType: "AMAZON.FOUR_DIGIT_NUMBER",
      BusinessDescription: "Four digit number"
    },
    {
      SlotType: "AMAZON.Festival",
      BusinessDescription: "Name of the festival"
    },
    {
      SlotType: "AMAZON.FictionalCharacter",
      BusinessDescription: "Name of the fictional character"
    },
    {
      SlotType: "AMAZON.FinancialService",
      BusinessDescription: "Name of the financial service"
    },
    {
      SlotType: "AMAZON.Food",
      BusinessDescription: "Food item"
    },
    {
      SlotType: "AMAZON.FoodEstablishment",
      BusinessDescription: "Food establishment"
    },
    {
      SlotType: "AMAZON.Game",
      BusinessDescription: "Name of the game"
    },
    {
      SlotType: "AMAZON.Genre",
      BusinessDescription: "Name of the genre"
    },
    {
      SlotType: "AMAZON.LITERAL",
      BusinessDescription: "Any search phrase"
    },
    {
      SlotType: "AMAZON.Landform",
      BusinessDescription: "Landform value"
    },
    {
      SlotType: "AMAZON.LandmarksOrHistoricalBuildings",
      BusinessDescription: "Landmark of historical buildings value"
    },
    {
      SlotType: "AMAZON.Language",
      BusinessDescription: "Language name"
    },
    {
      SlotType: "AMAZON.LocalBusiness",
      BusinessDescription: "Local Business name"
    },
    {
      SlotType: "AMAZON.LocalBusinessType",
      BusinessDescription: "Local Business type"
    },
    {
      SlotType: "AMAZON.MedicalOrganization",
      BusinessDescription: "Name of the medical organization"
    },
    {
      SlotType: "AMAZON.Month",
      BusinessDescription: "Month name"
    },
    {
      SlotType: "AMAZON.MovieSeries",
      BusinessDescription: "Name of the movie series"
    },
    {
      SlotType: "AMAZON.MovieTheater",
      BusinessDescription: "Name of the movie theater"
    },
    {
      SlotType: "AMAZON.MusicAlbum",
      BusinessDescription: "Name of the music album"
    },
    {
      SlotType: "AMAZON.MusicCreativeWorkType",
      BusinessDescription: "Music creative work type value"
    },
    {
      SlotType: "AMAZON.MusicEvent",
      BusinessDescription: "Music event value"
    },
    {
      SlotType: "AMAZON.MusicGroup",
      BusinessDescription: "Music group name"
    },
    {
      SlotType: "AMAZON.MusicPlaylist",
      BusinessDescription: "Music playlist value"
    },
    {
      SlotType: "AMAZON.MusicRecording",
      BusinessDescription: "Music recording value"
    },
    {
      SlotType: "AMAZON.MusicVenue",
      BusinessDescription: "Music venue value"
    },
    {
      SlotType: "AMAZON.MusicVideo",
      BusinessDescription: "Music video name"
    },
    {
      SlotType: "AMAZON.Musician",
      BusinessDescription: "Name of the musician"
    },
    {
      SlotType: "AMAZON.NUMBER",
      BusinessDescription: "Numeric value"
    },
    {
      SlotType: "AMAZON.Organization",
      BusinessDescription: "Organization name"
    },
    {
      SlotType: "AMAZON.Person",
      BusinessDescription: "Person name"
    },
    {
      SlotType: "AMAZON.PostalAddress",
      BusinessDescription: "Postal address value"
    },
    {
      SlotType: "AMAZON.Professional",
      BusinessDescription: "Professional value"
    },
    {
      SlotType: "AMAZON.ProfessionalType",
      BusinessDescription: "Professional type value"
    },
    {
      SlotType: "AMAZON.RadioChannel",
      BusinessDescription: "Radio channel value"
    },
    {
      SlotType: "AMAZON.Residence",
      BusinessDescription: "Residence value"
    },
    {
      SlotType: "AMAZON.Room",
      BusinessDescription: "Room value"
    },
    {
      SlotType: "AMAZON.ScreeningEvent",
      BusinessDescription: "Searching event value"
    },
    {
      SlotType: "AMAZON.SearchQuery",
      BusinessDescription: "Search phrase"
    },
    {
      SlotType: "AMAZON.Service",
      BusinessDescription: "Service value"
    },
    {
      SlotType: "AMAZON.SocialMediaPlatform",
      BusinessDescription: "Social medial platform name"
    },
    {
      SlotType: "AMAZON.SoftwareApplication",
      BusinessDescription: "Software application value"
    },
    {
      SlotType: "AMAZON.SoftwareGame",
      BusinessDescription: "Software game value"
    },
    {
      SlotType: "AMAZON.Sport",
      BusinessDescription: "Name of the sport"
    },
    {
      SlotType: "AMAZON.SportsEvent",
      BusinessDescription: "Name of the sport event"
    },
    {
      SlotType: "AMAZON.SportsTeam",
      BusinessDescription: "Name of the sport team"
    },
    {
      SlotType: "AMAZON.StreetAddress",
      BusinessDescription: "Street address value"
    },
    {
      SlotType: "AMAZON.TIME",
      BusinessDescription: "Time period value"
    },
    {
      SlotType: "AMAZON.TVEpisode",
      BusinessDescription: "TV episode value"
    },
    {
      SlotType: "AMAZON.TVSeason",
      BusinessDescription: "TV season value"
    },
    {
      SlotType: "AMAZON.TVSeries",
      BusinessDescription: "TV series value"
    },
    {
      SlotType: "AMAZON.TelevisionChannel",
      BusinessDescription: "Television channel value"
    },
    {
      SlotType: "AMAZON.US_CITY",
      BusinessDescription: "City name"
    },
    {
      SlotType: "AMAZON.US_FIRST_NAME",
      BusinessDescription: "First name value"
    },
    {
      SlotType: "AMAZON.US_STATE",
      BusinessDescription: "State name"
    },
    {
      SlotType: "AMAZON.VideoGame",
      BusinessDescription: "Name of the video game"
    },
    {
      SlotType: "AMAZON.WeatherCondition",
      BusinessDescription: "Weather condition value"
    },
    {
      SlotType: "AMAZON.WrittenCreativeWorkType",
      BusinessDescription: "Written creative work type value"
    }
  ]
};
